import http from './utils';
import { prefix } from './constants';
 
type TApiFunction<TPayload = any, TResponse = any> = (
  payload: TPayload,
) => Promise<TResponse>;

export const getVideoTableList: (
  payload: any,
) => Promise<any> | any = payload => {
  return http({
    url: `${prefix}/hotspot/video/list`,
    method: 'post',
    ...payload,
  }) as Promise<any>;
};

export const getVideoDownloadUrl: TApiFunction = payload => {
  return http({
    url: `${prefix}/hotspot/video/download`,
    method: 'post',
    errorHandler: true,
    ...payload,
  }) as Promise<any>;
};

export const getXVideoList: TApiFunction = payload => { 
  return http({
    url: `${prefix}/hotspot/video/x/list`,
    method: 'post',
    ...payload,
  }) as Promise<any>;
};

export const getBilibiliVideoList: TApiFunction = payload => {
  return http({
    url: `${prefix}/hotspot/video/bilibili/list`,
    method: 'post',
    ...payload,
  }) as Promise<any>;
};

export const getDouyinVideoList: TApiFunction = payload => {
  return http({
    url: `${prefix}/hotspot/video/douyin/list`,
    method: 'post',
    ...payload,
  }) as Promise<any>;
};
